export const TWO_COLOR_SHADES = {
    green: {
      dark: "#1eb700",
      light: "#dbffd3"
    },
    red: {
      dark: "#ff342d",
      light: "#ffdfdf"
    },
    blue: {
      dark: "#3366ff",
      light: "#eff4ff"
    },
    skyblue: {
      dark: "#00a6ff",
      light: "#dbf3ff"
    },
    purple: {
      dark: "#8c00ff",
      light: "#f2e2ff"
    },
    pink: {
      dark: "#e700fe",
      light: "#fde7ff"
    },
    chocolate: {
      dark: "#97706e",
      light: "#f4d9d9"
    },
    yellow: {
      dark: "#ffd800",
      light: "#fff9e6"
    }
  }